<template>
  <div class="input-checkbox-item">
    <input type="checkbox" :id="id" :value="value" v-model="form[name]" />
    <label :for="id" class="checkbox-label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: ["name", "label", "value", "id"],
  computed: {
    form() {
      return this.$parent.form;
    },
    errors() {
      return this.$parent.form.errors;
    },
  },
  mounted() {
    this.form.load(this.name, []);
  },
};
</script>
